import { Injectable } from "@angular/core";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { FileUploadComponent } from "../components";
import { IFileStatusVM, IFileUploadOptionsVM } from "../models";

@Injectable({
    providedIn: 'root',
})
export class FileUploadService {
    constructor(private modalService: BsModalService) { }

    showFileUpload(doneCallback: (uploadedFiles: IFileStatusVM[]) => void, fileOptions: IFileUploadOptionsVM = {}): BsModalRef<FileUploadComponent> {
        const defaultOptions: IFileUploadOptionsVM = {
            title: 'File Uploader',
            message: 'Drag and Drop Your Document or Click to Upload',
            accept: '*/*',
            uploadedFiles: [],
        };

        const options: ModalOptions = {
            class: 'modal-form-default modal-dialog-centered modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                options: Object.assign(defaultOptions, JSON.parse(JSON.stringify(fileOptions))),
                callback: doneCallback
            }
        };

        return this.modalService.show(FileUploadComponent, options);
    }
}